// Where the operator's admin key lives while the console is open.
//
// The Notifications tab has always prompted for this key and kept it here; now
// that every /api/admin route requires it, the same slot backs the whole
// dashboard. sessionStorage, not localStorage, so closing the tab drops it —
// and it is never part of the build output.

export const ADMIN_KEY_STORAGE = 'valet_admin_key';

export const getAdminKey = () => {
    try {
        return sessionStorage.getItem(ADMIN_KEY_STORAGE) || '';
    } catch {
        // Safari private mode throws on sessionStorage access.
        return '';
    }
};

export const setAdminKey = (key) => {
    try {
        sessionStorage.setItem(ADMIN_KEY_STORAGE, key);
    } catch {
        /* nothing useful to do — the gate will simply ask again */
    }
};

export const clearAdminKey = () => {
    try {
        sessionStorage.removeItem(ADMIN_KEY_STORAGE);
    } catch {
        /* as above */
    }
};

// Thrown by adminService when the API answers 401, so the dashboard can drop
// back to the unlock screen instead of showing a generic red box on every tab.
export class AdminKeyRejected extends Error {
    constructor(message = 'That admin key was not accepted.') {
        super(message);
        this.name = 'AdminKeyRejected';
    }
}
